import React from 'react';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { AssetLibraryApiClient } from '@ael/core-api';
import { PortalApiClient } from '../rest-api/portalApiClient';
import { PageNotFound } from '../pages/error/PageNotFound';
import type { RouterAuth } from '../plugins/auth/Authentication';

export type RouterContext = {
  queryClient: QueryClient;
  apiClient: PortalApiClient;
  /** Bound to Auth0 tokens like `apiClient`; scope it to a company with `createCompanyScopedAssetLibraryClient`. */
  assetLibraryApiClient: AssetLibraryApiClient;
  auth: RouterAuth;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: PageNotFound,
});
